angular.module('main').directive('thCalendarWeek', () => ({
	restrict: 'AE',
	template:
		'<tr>' +
		'<td class="td-empty"></td>' +
		'<td class="row-day-head" ng-repeat="day in week | orderBy track by $index">' +
		'{{day.date | date: "EEE dd" }}' +
		'</td>' +
		'</tr>',
	scope: {
		week: '=snWeek'
	},
	replace: true,
	transclude: true
}));



// WEBPACK FOOTER //
// ./web/js/components/PageCalendar/thCalendarWeek.js